import { render, staticRenderFns } from "./BrowserPdfPrinter.vue?vue&type=template&id=544f6e8a&scoped=true&"
import script from "./BrowserPdfPrinter.vue?vue&type=script&lang=ts&"
export * from "./BrowserPdfPrinter.vue?vue&type=script&lang=ts&"
import style0 from "./BrowserPdfPrinter.vue?vue&type=style&index=0&id=544f6e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f6e8a",
  null
  
)

export default component.exports